<!--
 * @Description: 用户持有银行卡信息操作组件，签约/解约 由index.js 配置引入
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 14:46:45
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc v-if="!embedded" back-url-name="bankmanager">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/bankmanager' }">银行卡管理</el-breadcrumb-item>
                <el-breadcrumb-item>银行卡签约/解约</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>

        <div :class="['bizcomp-sign-and-unsign', { 'embedded-mode': embedded }]">
            <div v-if="!embedded" class="header-title">银行卡签约/解约</div>
            <el-table :data="bankInfo" class="tab-list-tit table-list">
                <el-table-column
                    prop="bankcode"
                    label="银行卡名称"
                    align="center"
                    :formatter="formatterName"
                />
                <el-table-column
                    prop="depositcard"
                    label="银行卡号码"
                    align="center"
                ></el-table-column>
                <el-table-column
                    prop="signstatus"
                    label="签约状态"
                    align="center"
                    :formatter="formatterSignstatus"
                ></el-table-column>
                <el-table-column prop="signstatus" label="操作" align="center">
                    <template slot-scope="scope">
                        <span
                            :class="
                                (scope.row.signstatus == '0' && scope.row.identifytype != '0') ||
                                (scope.row.signstatus == '1' && scope.row.canunsign != '0')
                                    ? 'sign-operate'
                                    : ''
                            "
                            v-on:click="
                                (scope.row.signstatus == '0' && scope.row.identifytype != '0') ||
                                (scope.row.signstatus == '1' && scope.row.canunsign != '0')
                                    ? signOperate(scope.row)
                                    : ''
                            "
                        >
                            {{ scope.row.signstatus == "0" ? "签约" : "解约" }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog
                :title="dialogTitle"
                :visible.sync="dialogShow"
                class="prop info-tips"
                width="580px"
            >
                <div class="dialog-contain">
                    <div class="bank-contain">
                        <div class="bank-title">
                            银行全称：
                            <span class="bank-text">
                                {{ $cache.getDict("110080", selectBankInfo.bankcode) }}
                            </span>
                        </div>
                        <div class="bank-title">
                            银行卡号：
                            <span class="bank-text">{{ selectBankInfo.depositcard }}</span>
                        </div>
                        <div class="bank-title">
                            证件类型：
                            <span class="bank-text">
                                {{ $cache.getDict("130007", $cache.getUser().certificatetype) }}
                            </span>
                        </div>
                        <div class="bank-title">
                            银行卡证件号码：
                            <span class="bank-text">{{ $cache.getUser().certificateno }}</span>
                        </div>
                    </div>
                    <div class="checkbox-contain">
                        <el-checkbox v-model="checked" class="check-style"></el-checkbox>
                        <span class="agree-text">我已阅读并同意:</span>
                        <span class="agree-content" v-on:click="openFile">
                            《电子交易委托转账收付款服务协议(托收)》
                        </span>
                    </div>
                    <div class="btn-contain">
                        <button class="cancel-btn" v-on:click="dialogShow = false">取消</button>
                        <button
                            :disabled="!checked"
                            :class="
                                'confirm-btn ' +
                                (!checked ? 'confirm-btn-disabled' : 'confirm-btn-active')
                            "
                            v-on:click="sendBankConfirm"
                        >
                            确定
                        </button>
                    </div>
                </div>
            </el-dialog>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay && !embedded"
            class="footer-questions"
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footer-questions>
        <pdf-popup
            base64
            :visible="pdfVisible"
            :need-time="false"
            :read-file-info-list="currentFileInfoList"
            v-on:close="pdfVisible = false"
        ></pdf-popup>
        <my-dialog
            :title="agrData.title"
            :visible.sync="agrVisible"
            :dialog-close="agrVisibleHide"
            width="800px"
        >
            <div class="protocol-detail" v-html="agrData.content"></div>
            <div class="align-c">
                <el-button type="primary" style="width: 180px" v-on:click="agrVisibleHide">
                    确定
                </el-button>
            </div>
        </my-dialog>
        <mobile-code
            :mobile-visible="mobileVisible"
            :mobile-no="selectBankInfo.mobileno || $cache.getUser().mobileno"
            v-on:verify-in="getMobileCode"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import userApi from "@/api/user";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import PdfPopup from "@/components/util/pdfPopup";
import myDialog from "@/components/layout/myDialog.vue";
import warningHtml from "@/constant/warning_html.js";
import mobileCode from "@/components/layout/mobileCodeDc.vue";
import commonApi from "@/api/common";
import { sceneEnum } from "@/util/util_jfit";

export default {
    name: "AddBank",
    components: { footerQuestions, PdfPopup, myDialog, mobileCode },
    mixins: [mixin],
    props: {
        embedded: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            dialogShow: false,
            checked: false,
            bankInfo: [],
            selectBankInfo: {},
            unSignSendParam: {},
            commonQuestion: [],
            warningHtml: "",
            pdfVisible: false,
            agrVisible: false,
            agrData: {},
            currentFileInfoList: [],
            dialogTitle: "",
            mobileVisible: false
        };
    },
    watch: {
        dialogShow(val) {
            if (!val) {
                this.checked = false;
            }
        }
    },
    created() {
        this.warningHtml = warningHtml.warningHtml3;
        this.commonQuestion = this.$const.commonQuestion.commonQuestion2;
        this.getBankInfo();
    },
    methods: {
        getMobileCode(val) {
            this.mobileVisible = false;
            if (val) {
                this.checkVerifyCode(val);
            }
            return false;
        },
        /* 校验手机验证码 */
        async checkVerifyCode(val) {
            const isSign = this.selectBankInfo.signstatus === "0";
            const params = {
                biztype: isSign ? "02" : "01",
                smscode: val
            };
            if (this.$cache.getIsEncrypted()) {
                params.en_mobileno =
                    this.selectBankInfo.en_mobileno || this.$cache.getUser().en_mobileno;
            } else {
                params.mobileno = this.selectBankInfo.mobileno || this.$cache.getUser().mobileno;
            }
            const res = await userApi.checkBindCardSms(params, this.$cache.getIsEncrypted());
            if (res.code == "0") {
                // 短信签约
                let isDecryptObj = {};
                if (this.$cache.getIsEncrypted()) {
                    isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                } else {
                    isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                }
                if (isSign) {
                    const reqRes = await userApi.combUpdateBankcardAuth(
                        {
                            ...isDecryptObj,
                            certificatetype: this.$cache.getUser().certificatetype,
                            bankcode: this.selectBankInfo.bankcode,
                            bankcardid: this.selectBankInfo.bankcardid,
                            paychannel: this.selectBankInfo.paycenterid
                        },
                        this.$cache.getIsEncrypted()
                    );
                    if (reqRes.code == "0" && reqRes.body) {
                        this.getBankInfo();
                        this.$message({
                            type: "success",
                            message: "银行卡签约成功!"
                        });
                    }
                } else {
                    // 短信解约
                    const params = {
                        ...this.unSignSendParam
                    };
                    if (this.$cache.getIsEncrypted()) {
                        params.en_depositcard = this.selectBankInfo.en_desendepositcard;
                    } else {
                        params.depositcard = this.selectBankInfo.desendepositcard;
                    }
                    const res = await userApi.combUnSignBankHandler(
                        params,
                        this.$cache.getIsEncrypted()
                    );
                    if (res.code == "0") {
                        this.getBankInfo();
                        this.$message({
                            type: "success",
                            message: "银行卡解约成功!"
                        });
                    }
                }
            }
        },
        openFile() {
            if (this.agrData.fileid == null || !this.agrData.fileid) {
                this.agrVisible = true;
            } else {
                this.pdfVisible = true;
            }
        },
        agrVisibleHide() {
            this.agrVisible = false;
        },
        getFileContent(fileType) {
            this.$util.getProtocol(fileType).then((res) => {
                if (res[0]) {
                    res[0].filename = res[0].title;
                    this.agrData = res[0];
                    this.currentFileInfoList = [res[0]];
                }
            });
        },
        async getBankInfo() {
            const reqRes = await userApi.getMyBankCards();
            const res = reqRes.data;
            if (res.data) {
                this.bankInfo = res.data ? res.data : [];
                // 根据配置参数判断是否展示柜台的卡
                this.bankInfo = this.bankInfo.filter((item) => {
                    return this.$util.showCounterCard() || item.banktype != "1";
                });
                const channelRes = await userApi.queryPaychannel();
                if (channelRes.data) {
                    const _arr = channelRes.data.paychannelInfoList
                        ? channelRes.data.paychannelInfoList
                        : [];
                    this.bankInfo.forEach((bankItem, bankIndex) => {
                        if (bankItem.specialflagofchannel.indexOf("t") > -1) {
                            this.$set(this.bankInfo[bankIndex], "identifytype", "1");
                        } else if (bankItem.specialflagofchannel.indexOf("u") > -1) {
                            this.$set(this.bankInfo[bankIndex], "identifytype", "2");
                        } else {
                            this.$set(this.bankInfo[bankIndex], "identifytype", "0");
                        }
                        _arr.forEach((channelItem) => {
                            if (bankItem.paycenterid == channelItem.paychannel) {
                                // 8为后台解约，a为页面解约
                                if (channelItem.businessflag.indexOf("8") > -1) {
                                    this.$set(this.bankInfo[bankIndex], "canunsign", "1");
                                    const isSms = channelItem.businessflag.indexOf("s") > -1;
                                    this.$set(this.bankInfo[bankIndex], "unsignSmsFlag", isSms);
                                } else if (channelItem.businessflag.indexOf("a") > -1) {
                                    this.$set(this.bankInfo[bankIndex], "canunsign", "2");
                                } else {
                                    this.$set(this.bankInfo[bankIndex], "canunsign", "0");
                                }
                                if (this.bankInfo[bankIndex].identifytype == "0") {
                                    if (channelItem.businessflag.indexOf("s") > -1) {
                                        this.$set(this.bankInfo[bankIndex], "identifytype", "1");
                                    } else if (channelItem.businessflag.indexOf("r") > -1) {
                                        this.$set(this.bankInfo[bankIndex], "identifytype", "2");
                                    }
                                }
                            }
                        });
                    });
                }
            }
        },
        formatterName(row, column, value) {
            return (
                this.$util.getChannelName(row) +
                "(" +
                this.$util.lastFour([row.desendepositcard, row.depositcardproc, row.depositcard]) +
                ")"
            );
        },
        formatterSignstatus(row, column, value) {
            return row.signstatus == "0" ? "未签约" : "已签约";
        },
        signOperate(bankInfo) {
            if (bankInfo.signstatus == "0") {
                this.dialogTitle = "银行卡签约";
                this.getFileContent(sceneEnum.sign);
            } else {
                this.dialogTitle = "银行卡解约";
                this.getFileContent(sceneEnum.unsign);
            }
            this.dialogShow = true;
            this.selectBankInfo = bankInfo;
        },
        sendBankConfirm() {
            this.dialogShow = false;
            if (this.currentFileInfoList.length > 0) {
                commonApi.agreementLeaveTracesLog(
                    this,
                    {
                        eventid:
                            this.$const.RECORD.cms_protocol_agreement_agree +
                            (this.bankInfo.signstatus == "0" ? "/p" : "/q"),
                        eventname: `协议同意`
                    },
                    this.currentFileInfoList
                );
            }
            if (this.selectBankInfo.signstatus == "0") {
                // 签约
                this.getParams(true);
            } else {
                // 解约
                this.getParams(false);
            }
        },
        async getParams(isSign) {
            let params = {};
            params.biztype = "02";
            params.certificatetype = this.$cache.getUser().certificatetype;
            params.bankcardid = this.selectBankInfo.bankcardid;
            params.channelid = this.selectBankInfo.paycenterid + this.selectBankInfo.bankcode;
            params.bankcode = this.selectBankInfo.bankcode;
            params.paychannel = this.selectBankInfo.paycenterid;
            params.signtype = "0";
            params.channelname =
                this.$cache.getDict("110079", this.bankInfo.paycenterid).toString().substr(0, 4) +
                "-" +
                this.$cache.getDict("110080", this.bankInfo.bankcode);
            if (this.$cache.getIsEncrypted()) {
                params.en_custname = this.$cache.getUser().en_custname;
                params.en_certificateno = this.$cache.getUser().en_certificateno;
                params.en_mobileno =
                    this.selectBankInfo.en_mobileno || this.$cache.getUser().en_mobileno;
                params.en_depositname = this.$cache.getUser().en_custname;
            } else {
                params.custname = this.$cache.getUser().custname;
                params.certificateno = this.$cache.getUser().certificateno;
                params.mobileno = this.selectBankInfo.mobileno || this.$cache.getUser().mobileno;
                params.depositname = this.$cache.getUser().custname;
            }
            this.$cache.getDict("110080", this.selectBankInfo.bankcode);
            this.randomToken = this.$util.generateRandomNumber();
            params.pagecallbackurl =
                window.location.origin +
                "" +
                "/sale-mid-ump/bank/redirect?token=" +
                this.randomToken;
            // 建行网联的回调地址配置在银行那边，需要单独处理
            if (this.bankInfo.paycenterid == "0105") {
                params.pagecallbackurl = window.location.origin + "" + "/sale-mid-ump/bank/ccb";
            }
            this.sendBank(params, isSign);
        },
        async sendBank(data, isSign) {
            this.unSignSendParam = {};
            let res = "";
            // 短信签约
            if (this.selectBankInfo.identifytype == "1" && isSign) {
                // 短信签约
                data.verifytype = "1";
                res = await userApi.sendBindCardSms(data, this.$cache.getIsEncrypted());
                if (res.data) {
                    this.mobileVisible = true;
                }
                return;
            }
            if (
                this.selectBankInfo.canunsign === "1" &&
                this.selectBankInfo.unsignSmsFlag &&
                !isSign
            ) {
                // 短信解约
                data.verifytype = "1";
                data.biztype = "01";
                res = await userApi.sendBindCardSms(data, this.$cache.getIsEncrypted());
                if (res.data) {
                    this.unSignSendParam = data;
                    this.mobileVisible = true;
                }
                return;
            }
            if (this.selectBankInfo.canunsign == "1" && !isSign) {
                // 后台解约
                if (this.$cache.getIsEncrypted()) {
                    data.en_depositcard = this.selectBankInfo.en_desendepositcard;
                } else {
                    data.depositcard = this.selectBankInfo.desendepositcard;
                }
                res = await userApi.combUnSignBankHandler(data, this.$cache.getIsEncrypted());
                if (res.code == "0") {
                    this.getBankInfo();
                    this.$message({
                        type: "success",
                        message: "银行卡解约成功!"
                    });
                }
                return;
            }
            // 页面签约，页面解约
            if (
                (this.selectBankInfo.identifytype == "2" && isSign) ||
                (this.selectBankInfo.canunsign == "2" &&
                    this.selectBankInfo.identifytype == "2" &&
                    !isSign)
            ) {
                if (isSign) {
                    data.verifytype = "0";
                    res = await userApi.sendBindCardSms(data, this.$cache.getIsEncrypted());
                } else {
                    res = await userApi.combUnSignApply(data, this.$cache.getIsEncrypted());
                }
                if (res.data) {
                    const pageUrl = res.data.bankgateurl ? res.data.bankgateurl : "";
                    let pageParam = res.data.bankgateparam ? res.data.bankgateparam : {};
                    if (pageParam) {
                        pageParam = JSON.parse(pageParam);
                    }
                    const bankgateserialno = res.data.bankgateserialno;
                    const reqMethod = res.data.method;
                    this.$util.openPostWindow(pageUrl, pageParam, reqMethod, "_blank");
                    let isDecryptObj = {};
                    if (this.$cache.getIsEncrypted()) {
                        isDecryptObj.en_certificateno = this.$cache.getUser().en_certificateno;
                        isDecryptObj.en_depositname = this.$cache.getUser().en_custname;
                    } else {
                        isDecryptObj.certificateno = this.$cache.getUser().certificateno;
                        isDecryptObj.depositname = this.$cache.getUser().custname;
                    }
                    const params = {
                        ...isDecryptObj,
                        token: this.randomToken,
                        certificatetype: this.$cache.getUser().certificatetype,
                        bankcode: this.selectBankInfo.bankcode,
                        mobileno: this.selectBankInfo.newMobile,
                        paychannel: this.selectBankInfo.paycenterid,
                        bankgateserialno: bankgateserialno,
                        signtype: "0"
                    };
                    if (this.$cache.getIsEncrypted()) {
                        params.en_depositcard = this.selectBankInfo.en_desendepositcard;
                    } else {
                        params.depositcard = this.selectBankInfo.desendepositcard;
                    }
                    if (this.selectBankInfo.bankcardid) {
                        params.bankcardid = this.selectBankInfo.bankcardid;
                    }
                    if (isSign) {
                        // 签约要做的操作
                        this.$util.confirmBankAuth(
                            this,
                            params,
                            "BankPageAuthentication",
                            async () => {
                                let isDecryptObj = {};
                                if (this.$cache.getIsEncrypted()) {
                                    isDecryptObj.en_certificateno =
                                        this.$cache.getUser().en_certificateno;
                                } else {
                                    isDecryptObj.certificateno =
                                        this.$cache.getUser().certificateno;
                                }
                                const res = await userApi.combUpdateBankcardAuth(
                                    {
                                        ...isDecryptObj,
                                        certificatetype: this.$cache.getUser().certificatetype,
                                        bankcode: this.selectBankInfo.bankcode,
                                        bankcardid: this.selectBankInfo.bankcardid,
                                        paychannel: this.selectBankInfo.paycenterid
                                    },
                                    this.$cache.getIsEncrypted()
                                );
                                if (res.code == "0" && res.body) {
                                    this.getBankInfo();
                                    this.$message({
                                        type: "success",
                                        message: "银行卡签约成功!"
                                    });
                                }
                            }
                        );
                    } else {
                        // 解约要做的操作
                        this.$util.confirmBankAuth(
                            this,
                            params,
                            "unSignBankPageAuthentication",
                            () => {
                                this.getBankInfo();
                                this.$message({
                                    type: "success",
                                    message: "银行卡解约成功!"
                                });
                            }
                        );
                    }
                }
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-sign-and-unsign {
    width: 1200px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    margin-top: 13px;
    padding-bottom: 40px;
    margin-bottom: 20px;
    .header-title {
        width: 1160px;
        padding: 17px 0 21px 0;
        margin-left: 20px;
        border-bottom: 1px solid #f1f1f1;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
    }
    .table-list {
        width: 1160px;
        max-height: 600px;
        overflow-y: auto;
        margin: auto;
        margin-top: 20px;
        border-left: 1px solid #f1f1f1;
        border-right: 1px solid #f1f1f1;
        .sign-operate {
            color: var(--color-primary);
            cursor: pointer;
        }
    }

    :deep(.el-table) {
        th {
            background: #f9f9f9 !important;
        }
    }
    .el-table::before {
        background: none;
    }
    .dialog-contain {
        padding: 28px 20px;
        .bank-contain {
            font-size: 18px;
            font-weight: normal;
            line-height: 40px;
            .bank-title {
                color: #666666;
            }
            .bank-text {
                color: #333333;
            }
            .password-contain {
                display: flex;
            }
            .password-input {
                width: 300px;
                margin-right: 5px;
            }
        }
        .checkbox-contain {
            margin: 30px 0 0 52px;
            font-size: 14px;
            font-weight: normal;
            line-height: 22px;
            .agree-text {
                margin-left: 4px;
                color: var(--color-text-primary);
            }
            .agree-content {
                color: var(--color-primary);
                cursor: pointer;
            }
        }

        .btn-contain {
            margin-top: 40px;
            .cancel-btn {
                margin-left: 50px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                background: #e4e4e4;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                color: #666666;
                cursor: pointer;
                border: none;
            }
            .confirm-btn {
                margin-left: 40px;
                width: 180px;
                height: 42px;
                line-height: 42px;
                border-radius: 2px;
                font-size: 16px;
                font-weight: 500;
                text-align: center;
                border: none;
                color: #ffffff;
            }
            .confirm-btn-active {
                background: var(--color-primary);
                cursor: pointer;
            }
            .confirm-btn-disabled {
                background: #f7b2b8;
            }
        }
    }
}

.bizcomp-sign-and-unsign.embedded-mode {
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
    .header-title,
    .table-list {
        width: calc(100% - 40px);
    }
}

.protocol-detail {
    padding: 20px 10px;
    max-height: 80vh;
    min-height: 10vh;
    overflow: scroll;
}
</style>
